import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Star, X } from 'lucide-react';

interface Props {
  selectedCount: number;
  onClear: () => void;
  onApprove: () => void;
  onReject: () => void;
  onFeature?: () => void;
  onUnfeature?: () => void;
  pending?: boolean;
}

export function BulkActionBar({ selectedCount, onClear, onApprove, onReject, onFeature, onUnfeature, pending }: Props) {
  if (selectedCount === 0) return null;
  return (
    <div className="sticky top-0 z-20 -mx-4 md:-mx-6 px-4 md:px-6 py-3 bg-primary text-primary-foreground rounded-md shadow-md flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" onClick={onClear} className="text-primary-foreground hover:bg-primary-foreground/10">
          <X className="h-4 w-4 mr-1" /> Clear
        </Button>
        <span className="text-sm font-medium">{selectedCount} selected</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {onUnfeature && (
          <Button variant="secondary" size="sm" onClick={onUnfeature} disabled={pending}>
            <Star className="h-4 w-4 mr-1" /> Unfeature
          </Button>
        )}
        {onFeature && (
          <Button variant="secondary" size="sm" onClick={onFeature} disabled={pending}>
            <Star className="h-4 w-4 mr-1" /> Feature
          </Button>
        )}
        <Button variant="destructive" size="sm" onClick={onReject} disabled={pending}>
          <XCircle className="h-4 w-4 mr-1" /> Bulk Reject
        </Button>
        <Button size="sm" variant="secondary" onClick={onApprove} disabled={pending} className="bg-white text-primary hover:bg-white/90">
          <CheckCircle2 className="h-4 w-4 mr-1" /> Bulk Approve
        </Button>
      </div>
    </div>
  );
}
